// import { ThreeDRotationSharp } from '@material-ui/icons';
import React, { Component } from 'react';

class RazorpayPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_payement_completed: false,
        }
    }
  componentDidMount() {
    this.loadRazorpayScript().then((loaded) => {
      if (loaded) {
        this.startPayment();
      } else {
        alert('Failed to load Razorpay script.');
      }
    });
  }

  loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      building_id: params.get('building_id'),
      app_id: params.get('app_id'),
      amount: params.get('amount'),
      coupon_code: params.get('coupon_code'),
    };
  };

  startPayment = () => {
    const { building_id, app_id, amount, coupon_code } = this.getUrlParams();

    if (!building_id || !app_id) {
      alert("Missing 'building_id', 'app_id', or 'amount' in the URL.");
      return;
    }

    fetch('/we/initiate-marketplace-payment/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRFToken': localStorage.getItem('csrftoken') },
      body: `amount=${amount}&building_id=${building_id}&app_id=${app_id}${coupon_code ? `&coupon_code=${coupon_code}` : ''}`,
    })
      .then((response) => response.json())
      .then((order) => {
        if (order.error) {
          alert(order.error);
        } else {
          const options = {
            key: 'rzp_test_FufiuxnptvjDaF',
            amount: order.amount,
            currency: 'INR',
            order_id: order.id,
            handler: (response) => {
              
              this.verifyPayment(response, order, building_id, app_id, coupon_code);
            },
            theme: { color: '#3399cc' },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();
        }
      })
      .catch(() => alert('Service unavailable'));
  };

  verifyPayment = (response, order, building_id, app_id, coupon_code) => {
    fetch('/we/verify-marketplace-payment/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRFToken': localStorage.getItem('csrftoken') },
      body: `razorpay_payment_id=${response.razorpay_payment_id}&razorpay_order_id=${order.id}&razorpay_signature=${response.razorpay_signature}&building_id=${building_id}&app_id=${app_id}&coupon_code=${coupon_code}`,
    }).then((response) => {
        this.setState({is_payement_completed: true})
        alert("Thank you! Your payment was successful. Return to the OKAS app to explore more.")
    }).catch((err) => {
        alert("Payemnt Verification Failed")
    });
  };

  render() {
    const containerStyle = {
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#f2f2f2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      margin: 0,
    };

    const paymentContainerStyle = {
      backgroundColor: '#fff',
      padding: '20px 30px',
      borderRadius: '12px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      width: '100%',
      maxWidth: '400px',
    };

    const loaderStyle = {
      border: '6px solid #f3f3f3',
      borderTop: '6px solid #3498db',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
      margin: '20px auto',
    };

    return (
      <div style={containerStyle}>
        {this.state.is_payement_completed === true ?  (
      <div style={paymentContainerStyle}>
        <h1 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>
          Thank You for the Payment
        </h1>
        <p style={{ fontSize: '14px', color: '#666' }}>
          Your payment was successful. You can now return to the OKAS app to explore more.
        </p>
      </div>
    )  : 
        <div style={paymentContainerStyle}>
          <h1 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>Processing Payment</h1>
          <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
            Please wait while we redirect you to the payment gateway...
          </p>
          <div style={loaderStyle}></div>
          <p style={{ fontSize: '12px', color: '#999' }}>Do not refresh or close this page.</p>
        </div>
        }
      </div>
    );
  }
}

export default RazorpayPayment;


// import React, { Component } from "react";

// class RazorpayPayment extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             countries: [],
//             states: [],
//             cities: [],
//             selectedCountry: "",
//             selectedState: ""
//         };
//     }

//     componentDidMount() {
//         this.fetchCountries();
//     }

//     async fetchCountries() {
//         const query = `[out:json]; relation["admin_level"="2"]; out tags;`;
//         const url = `https://overpass-api.de/api/interpreter?data=${encodeURIComponent(query)}`;

//         try {
//             const response = await fetch(url);
//             const data = await response.json();
//             const countryList = data.elements.map((country) => country.tags["name:en"] || country.tags.name);
//             this.setState({ countries: countryList });
//         } catch (error) {
//             console.error("Error fetching countries:", error);
//         }
//     }

//     async fetchStates(countryName) {
//         const query = `[out:json]; area["name:en"="${countryName}"]->.searchArea; relation["admin_level"="4"](area.searchArea); out tags;`;
//         const url = `https://overpass-api.de/api/interpreter?data=${encodeURIComponent(query)}`;

//         try {
//             const response = await fetch(url);
//             const data = await response.json();
//             const stateList = data.elements.map((state) => state.tags["name:en"] || state.tags.name);
//             this.setState({ states: stateList, selectedCountry: countryName, selectedState: "", cities: [] });
//         } catch (error) {
//             console.error("Error fetching states:", error);
//         }
//     }

//     async fetchCities(stateName) {
//         const query = `[out:json]; area["name:en"="${stateName}"]->.searchArea; node["place"="city"](area.searchArea); out tags;`;
//         const url = `https://overpass-api.de/api/interpreter?data=${encodeURIComponent(query)}`;

//         try {
//             const response = await fetch(url);
//             const data = await response.json();
//             const cityList = data.elements.map((city) => city.tags["name:en"] || city.tags.name);
//             this.setState({ cities: cityList, selectedState: stateName });
//         } catch (error) {
//             console.error("Error fetching cities:", error);
//         }
//     }

//     handleCountryChange = (event) => {
//         const selectedCountry = event.target.value;
//         this.fetchStates(selectedCountry);
//     };

//     handleStateChange = (event) => {
//         const selectedState = event.target.value;
//         this.fetchCities(selectedState);
//     };

//     render() {
//         return (
//             <div>
//                 <h2>Select Location</h2>

//                 {/* Country Dropdown */}
//                 <select onChange={this.handleCountryChange}>
//                     <option value="">Select Country</option>
//                     {this.state.countries.map((country, index) => (
//                         <option key={index} value={country}>{country}</option>
//                     ))}
//                 </select>

//                 {/* State Dropdown */}
//                 {this.state.selectedCountry && (
//                     <select onChange={this.handleStateChange}>
//                         <option value="">Select State</option>
//                         {this.state.states.map((state, index) => (
//                             <option key={index} value={state}>{state}</option>
//                         ))}
//                     </select>
//                 )}

//                 {/* City Dropdown */}
//                 {this.state.selectedState && (
//                     <select>
//                         <option value="">Select City</option>
//                         {this.state.cities.map((city, index) => (
//                             <option key={index} value={city}>{city}</option>
//                         ))}
//                     </select>
//                 )}
//             </div>
//         );
//     }
// }

// export default RazorpayPayment;


